import * as React from 'react';
import {
    CardMedia,
    IconButton,
    makeStyles,
    Tooltip,
    Box,
} from '@material-ui/core';
import { CostumeEntry } from '../../../sprite';
import DeleteIcon from '@material-ui/icons/Delete';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';

import HoveringCard from '../HoveringCard/HoveringCard';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    media: {
        objectFit: "contain" as any,
        flex: 1,
        overflow: "hidden",
        aspectRatio: "4 / 3"
    },
    footer:{
        display: "flex",
        width: "20px",
        textAlign: "right",
        padding: "0px 10px 0px 10px",
    },
    header: {
        padding: "10px 10px 5px 10px"
    }
});

/***
 * Props for the {@link CostumeDisplay} component.
 */
interface CostumeDisplayProps {
    readonly index: number;
    readonly isActive: boolean;
    /** The costume to container */
    readonly costume: CostumeEntry;
    /** Called when the delete icon is clicked */
    readonly deleteCostume?: (costume: CostumeEntry) => void;
    /** Called when the container was clicked */
    readonly onCostumeClicked?: (costume: CostumeEntry) => void;
    /** Called when the name was changed */
    readonly onCostumeNameChanged?: (costume: CostumeEntry) => void;
    /** Optional Readonly-flag which forbids editing the title and setting the deleteable state */
    readonly readonly?: boolean;
    /** Optional method called when right-clicking the costume */
    readonly setIsSystemState?: (costume: CostumeEntry) => void;
    /** Number of Costumes*/
    readonly onlyCostume?: boolean;
}

// const MAX_NAME_LENGTH = 20;

/***
 * Container for displaying a costume.
 * It provides an interface for deletion and changing the name.
 * Callbacks can be injected via the component props.
 */
const CostumeDisplay: React.FC<CostumeDisplayProps> = (props) => {
    // const [editName, setEditName] = React.useState(false);
    const [isSystemCostumeState, setIsSystemCostumeState] = React.useState(props.costume.isSystemCostume);

    // const handleNameInputTrigger = (e?: React.MouseEvent | React.FocusEvent) => {
    //     if (e) {
    //         e.stopPropagation();
    //     }
    //     if (editName) {
    //         if (props.onCostumeNameChanged) {
    //             props.onCostumeNameChanged(props.costume);
    //         }
    //     }
    //     setEditName(!editName);
    // };

    // const catchEnterKey = (e: React.KeyboardEvent) => {
    //     if (editName && e.key === "Enter") {
    //         handleNameInputTrigger();
    //     }
    // };

    // const handleCostumeNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     if (e.target.value.length <= MAX_NAME_LENGTH) {
    //         props.costume.name = e.target.value;
    //     }
    // };

    const classes = useStyles(props);
    const {t} = useTranslation();

    // let titleElement;
    // if (editName) {
    //     titleElement =
    //         (
    //             <FormControl>
    //                 <Input
    //                     multiline={true}
    //                     autoFocus={true}
    //                     onBlur={handleNameInputTrigger}
    //                     onKeyDown={catchEnterKey}
    //                     defaultValue={props.costume.name.replace(".png","")}
    //                     onChange={handleCostumeNameChange}
    //                     id="costumeName"
    //                     inputProps={{maxLength: MAX_NAME_LENGTH}}
    //                 />
    //             </FormControl>
    //         );
    // } else {
    //     if (props.costume.isSystemCostume) {
    //         titleElement =
    //             (
    //                 <Typography
    //                     style={{wordWrap: "break-word", maxHeight: "1.75rem"}}
    //                     variant="subtitle1"
    //                 >
    //                     {props.costume.name.replace(".png","")}
    //                 </Typography>
    //             );

    //     } else {
    //         titleElement =
    //             (
    //                 <Tooltip title={t('CostumeDisplay.ChangeNameTooltip') as string}>
    //                     <Typography
    //                         style={{wordWrap: "break-word", maxHeight: "1.75rem"}}
    //                         onClick={handleNameInputTrigger}
    //                         variant="subtitle1"
    //                     >
    //                         {props.costume.name.replace(".png","")}
    //                     </Typography>
    //                 </Tooltip>
    //             );
    //     }

    // }

    let costumeDeleteElement = [];
    /* Create delete and system buttons*/
    if (props.deleteCostume && !props.costume.isSystemCostume && !props.onlyCostume) {
        costumeDeleteElement.push(
            <Tooltip style={{marginBottom: "auto"}} title={t('CostumeDisplay.DeleteCostumeTooltip') as string}>
                <IconButton style={{ backgroundColor: '#CB253D', border: '2px solid rgb(111, 34, 18)', cursor: 'pointer', width: "42px", height: "42px" }} onClick={() => props.deleteCostume!(props.costume)} >
                    <DeleteIcon style={{ color: 'white', width: "20px", height: "20px" }} />
                </IconButton>
            </Tooltip>);
    }
    if (props.setIsSystemState) {
        costumeDeleteElement.push(
            <Tooltip style={{marginTop: "auto"}} title={t('CostumeDisplay.SetSystemCostumeTooltip') as string}>
                <IconButton size={'small'}
                            onClick={(event) => {
                                event.stopPropagation();
                                props.setIsSystemState!(props.costume);
                                setIsSystemCostumeState(props.costume.isSystemCostume);
                            }}>
                    {
                        isSystemCostumeState ? <LockIcon/> : <LockOpenIcon/>
                    }
                </IconButton>
            </Tooltip>
        );
    }

    const avatarBg1 = (fillColor: string, strokeColor: string) => {
        return `<svg width="140" height="132" viewBox="0 0 140 132" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M56.3689 124.271C5.27609 119.041 9.61989 105.582 14.1547 52.6661C16.3241 27.3514 40.0682 22.2875 75.26 15.7703C132.718 5.1296 130.962 20.0142 127.068 97.5491C125.786 123.096 89.0958 127.621 56.3689 124.271Z" fill="${fillColor}"/>
      <path d="M57.9466 117.294C12.7956 112.694 16.6355 100.832 20.6479 54.1995C22.5675 31.8906 43.5509 27.4241 74.6511 21.6749C125.429 12.2881 123.875 25.4054 120.427 93.7334C119.291 116.247 86.8674 120.241 57.9466 117.294Z" stroke="${strokeColor}" stroke-width="2.8764" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="7.19 7.19"/>
      </svg>
      `
      }
      const avatarBg2 = (fillColor: string, strokeColor: string) => {
        return `<svg width="118" height="103" viewBox="0 0 118 103" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.42074 33.2146C22.5271 -4.26903 34.7435 0.967248 84.7581 12.1624C108.685 17.5181 109.779 36.0423 110.454 63.3519C111.555 107.941 97.563 104.432 23.8429 90.0878C-0.446761 85.3617 1.02565 57.2242 9.42074 33.2146Z" fill="${fillColor}"/>
        <path d="M15.2554 35.352C26.8263 2.22554 37.6049 6.85081 81.7346 16.7356C102.846 21.4645 103.809 37.8342 104.4 61.9676C105.364 101.371 93.018 98.2719 27.9718 85.6085C6.54002 81.4361 7.84388 56.5707 15.2554 35.352Z" stroke="${strokeColor}" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="10 10"/>
        </svg>
        `
      }
      
      const avatarBackgrounds = (fillColor: string, strokeColor: string) => {
        return [avatarBg1(fillColor, strokeColor), avatarBg2(fillColor, strokeColor)]
      }
      

    const containerStyles = {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }
    
    //   const imageStyles = {
    //     width: '96px',
    //     height: '96px',
    //     position: 'relative',
    //     objectFit: 'contain',
    //     objectPosition: 'center',
    //     padding: '12px',
    //   }
    
      const backgroundsArray = props.isActive
        ? avatarBackgrounds('#4DB564', '#328129')
        : avatarBackgrounds('none', '#093914')
      const background = backgroundsArray[props.index % backgroundsArray.length] || ''

    return (
        <HoveringCard
            style={{height: "100%", display: "flex", alignContent: "center", justifyContent: "center", backgroundColor: "#438652"}}
            onClick={() => props.onCostumeClicked && props.onCostumeClicked(props.costume)}>
            <div
            style={{
                ...containerStyles,
                backgroundImage: `url('data:image/svg+xml;charset=utf8,${encodeURIComponent(background)}')`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
            } as React.CSSProperties}>
                <CardMedia
                    className={classes.media}
                    component="img"
                    src={props.costume.image.src}
                    style={{ margin: 'auto' }}
                />
                <Box display={"flex"} flexDirection={"column"} height={"100%"} style={{ position: "absolute", top: 0, right: 0 }}>
                    {costumeDeleteElement}
                </Box>
            </div>
        </HoveringCard>
    );
};

export default CostumeDisplay;
